import { inject } from '@angular/core';
import {
  ISubscriptionConfig,
  ISubscriptionTicket,
  SUBSCRIPTION_CONFIG_SCHEMA,
  SUBSCRIPTION_TICKETS,
} from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../../app-config.service';
import { IGetGateway, IListGateway } from '../../gateways';

export class ActiveSubscriptionGateway
  implements
    IGetGateway<string, IApiResponse<ISubscriptionConfig>>,
    IListGateway<number, IApiResponse<ISubscriptionTicket[]>>
{
  private readonly restCallBuilder: RestCallBuilder<ISubscriptionConfig> =
    new RestCallBuilder<ISubscriptionConfig>({} as ISubscriptionConfig);
  private readonly listRestCallBuilder: RestCallBuilder<ISubscriptionTicket[]> =
    new RestCallBuilder<ISubscriptionTicket[]>([]);
  private readonly configService: AppConfigService = inject(AppConfigService);

  get(uuid: string): Observable<IApiResponse<ISubscriptionConfig>> {
    return this.restCallBuilder
      .getExternal(
        this.configService.get().general.webshopApiUrl +
          `/api/subscriptions/subscription-configuration/${encodeURIComponent(uuid)}`
      )
      .validate(
        API_RESPONSE_SCHEMA(SUBSCRIPTION_CONFIG_SCHEMA),
        'SubscriptionConfig.get'
      )
      .handleMessages()
      .build();
  }

  list(serviceAreaId: number): Observable<IApiResponse<ISubscriptionTicket[]>> {
    return this.listRestCallBuilder
      .getExternal(
        this.configService.get().general.webshopApiUrl + '/api/subscriptions/all',
        {
          serviceAreaId: serviceAreaId,
        }
      )
      .validate(API_RESPONSE_SCHEMA(SUBSCRIPTION_TICKETS), 'Subscription.list')
      .handleMessages()
      .build();
  }
}
